/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../../types/graph';

import * as Operations from './query.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type StartQueryVariables = SchemaTypes.Exact<{
  uuid: SchemaTypes.Scalars['ID']['input'];
}>;


export type StartQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, identityProfile: { __typename?: 'IdentityProfile', id: string, email: string | null, firstName: string | null } } | null };


export function useStartQuery(baseOptions: Apollo.QueryHookOptions<StartQuery, StartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartQuery, StartQueryVariables>(Operations.Start, options);
      }
export function useStartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartQuery, StartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartQuery, StartQueryVariables>(Operations.Start, options);
        }
export type StartQueryHookResult = ReturnType<typeof useStartQuery>;
export type StartLazyQueryHookResult = ReturnType<typeof useStartLazyQuery>;